import React from 'react';
import styles from './styles/load-bot-message.module.css';

const LoadBotMessage = () => {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.dot} ${styles.pulse}`} />
      <div className={`${styles.dot} ${styles.pulse}`} />
      <div className={`${styles.dot} ${styles.pulse}`} />
    </div>
  );
};

export default LoadBotMessage;
